var map = {
	"./chat.svg": 74797,
	"./courseware.svg": 66404,
	"./full-screen.svg": 67062,
	"./guest.svg": 68322,
	"./help.svg": 17086,
	"./more.svg": 43205,
	"./mute-audio-fill.svg": 92074,
	"./mute-audio.svg": 22947,
	"./mute-video-fill.svg": 11141,
	"./mute-video.svg": 32621,
	"./open-audio-fill.svg": 85205,
	"./open-audio.svg": 38158,
	"./open-video-fill.svg": 49964,
	"./open-video.svg": 65559,
	"./screen.svg": 50170,
	"./setting.svg": 81633,
	"./switch.svg": 7207,
	"./view-user.svg": 40495
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88091;